// import Vue from 'vue'
import App from './App';
import MetaInfo from 'vue-meta-info';
//bootstrap样式文件
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../node_modules/bootstrap/dist/js/bootstrap.min.js'

import VueCookies from 'vue-cookies'
//说是为了跨域，感觉没啥用
// import cors from 'cors'

import VueAwesomeSwiper from 'vue-awesome-swiper'

import router from './router'
import store from './store'//引入store

//vue-lazyload图片懒加载
import VueLazyload from 'vue-lazyload'
import MyButton from './components/Button';

import axios from './api/api.js'
import VueAxios from 'vue-axios'
import "babel-polyfill";
// import VideoPlayer from 'vue-video-player'
// Vue.use(VideoPlayer);
if(window.VueVideoPlayer){
  Vue.use(window.VueVideoPlayer);
}

//使用了vue-axios，不需要这行
// Vue.prototype.$axios = axios // 全局注册，使用方法为:this.$axios
axios.defaults.withCredentials = true

Vue.use(MetaInfo);
Vue.use(VueAwesomeSwiper)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.use(VueCookies)
// Vue.use(cors)
Vue.use(VueLazyload)


Vue.component('myButton',MyButton);

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App),
  /* 这句非常重要，否则预渲染将不会启动 */
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})


// WEBPACK FOOTER //
// ./src/main.js